import {
  Breakpoint, greater,
} from './breakpoint'

export enum ColumnWidth {
  Full = 12,
  Wider = 10,
  Wide = 8,
  Half = 6,
  Narrow = 4,
  OneFourth = 3,
  OneSixth = 2,
  OneTwelth = 1,
}

// See _layout.scss
export const breakpointColumns = {
  default: 2,
  [greater(Breakpoint.MediumSmall)]: 12,
}
